<template>
  <CDropdown>
    <CDropdownToggle placement="bottom-end" class="py-0 text-end" :caret="false">
      <strong style="font-weight: bold; padding-right: 8px; color: white">
        {{ merchantName }}
        <font-awesome-icon icon="caret-down" title="Add Operator" style="
            cursor: pointer;
            color: white;
            font-size: 20;
            padding-left: 4px;
          " v-if="merchantList.length >= 1" />
      </strong>
    </CDropdownToggle>
    <CDropdownMenu class="pt-0" v-if="merchantList.length >= 1">
      <CDropdownItem v-for="merchant in merchantList" :key="merchant" style="cursor: pointer"
        @click="switchMerchant(merchant.merchantId)">
        {{ merchant.merchant }}
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
  <Modal :title="modalTitle" :message="modalMessage" :successModalShow="successModalShow" :reload="reloadPage"
    :close="closeModal"></Modal>
</template>

<script>
import Modal from '@/views/Components/Modal.vue'
import { useLoading } from 'vue-loading-overlay'

export default {
  name: 'AppHeaderDropdownMerchant',
  components: { useLoading, Modal },
  setup() {
    return { loading: useLoading() }
  },
  data() {
    return {
      merchantName: '',

      merchantList: [],

      modalTitle: '',
      modalMessage: '',
      successModalShow: false
    }
  },

  methods: {
    switchMerchant(merchantId) {
      this.$url
        .post(
          '/merchant/' + merchantId + '/operator/login',
          {},
          {
            headers: {
              'X-MOCO-MPS-TOKEN': sessionStorage.getItem('token')
            }
          }
        )
        .then((res) => {
          sessionStorage.setItem('token', res.headers['x-moco-mps-token'])
          sessionStorage.setItem('operatorId', res.data.id)
          sessionStorage.setItem('operatorName', res.data.name)
          sessionStorage.setItem('status', res.data.status)
          sessionStorage.setItem('roleId', res.data.role.id)
          sessionStorage.setItem('merchantId', res.data.merchant.id)
          sessionStorage.setItem('merchantName', res.data.merchant.name)

          var selectedTerminalPermissions = []
          var selectedOperatorPermissions = []
          var selectedMerchantPermissions = []
          var selectedOutletPermissions = []
          var selectedTransactionPermissions = []
          var selectedAdvicePermissions = []
          var selectedActivityLogPermissions = []
          var selectedRoleManagementPermissions = []
          var selectedReportPermissions = []

          for (var i = 0; i < res.data.role.permissions.length; i++) {
            if (res.data.role.permissions[i]['section'] == 'Terminal') {
              selectedTerminalPermissions.push(
                res.data.role.permissions[i]['operation']
              )
            } else if (res.data.role.permissions[i]['section'] == 'Operator') {
              selectedOperatorPermissions.push(
                res.data.role.permissions[i]['operation']
              )
            } else if (res.data.role.permissions[i]['section'] == 'Merchant') {
              selectedMerchantPermissions.push(
                res.data.role.permissions[i]['operation']
              )
            } else if (res.data.role.permissions[i]['section'] == 'Outlet') {
              selectedOutletPermissions.push(
                res.data.role.permissions[i]['operation']
              )
            } else if (
              res.data.role.permissions[i]['section'] == 'Transaction'
            ) {
              selectedTransactionPermissions.push(
                res.data.role.permissions[i]['operation']
              )
            } else if (res.data.role.permissions[i]['section'] == 'Advice') {
              selectedAdvicePermissions.push(
                res.data.role.permissions[i]['operation']
              )
            } else if (
              res.data.role.permissions[i]['section'] == 'Activity Log'
            ) {
              selectedActivityLogPermissions.push(
                res.data.role.permissions[i]['operation']
              )
            } else if (
              res.data.role.permissions[i]['section'] == 'Role Management'
            ) {
              selectedRoleManagementPermissions.push(
                res.data.role.permissions[i]['operation']
              )
            } else if (res.data.role.permissions[i]['section'] == 'Report') {
              selectedReportPermissions.push(
                res.data.role.permissions[i]['operation']
              )
            }
            sessionStorage.setItem(
              'permissionsData',
              JSON.stringify({
                terminalPermissions: selectedTerminalPermissions,
                operatorPermissions: selectedOperatorPermissions,
                merchantPermissions: selectedMerchantPermissions,
                outletPermissions: selectedOutletPermissions,
                transactionPermissions: selectedTransactionPermissions,
                advicePermissions: selectedAdvicePermissions,
                activityLogPermissions: selectedActivityLogPermissions,
                roleManagementPermissions: selectedRoleManagementPermissions,
                reportPermissions: selectedReportPermissions
              })
            )
          }
          this.modalTitle = 'Switch Merchant Successful'
          this.modalMessage =
            'Switch Merchant to "' +
            sessionStorage.merchantName +
            '" has been Successful.'

          if (this.$route.name.toLowerCase() == 'dashboard') {
            this.successModalShow = true
          } else {
            var modalData = {
              modalTitle: this.modalTitle,
              modalMessage: this.modalMessage,
              action: 'switch'
            }
            this.$store.commit('setModalProperties', modalData)
            this.$router.push({ name: 'Dashboard' })
          }
        })
        .catch((error) => {
          this.modalTitle = 'Login Failed'
          this.modalMessage = error.response.data
          this.unsuccessModalShow = true
        })
    },

    closeModal() {
      this.successModalShow = false
      this.unsuccessModalShow = false
    },

    reloadPage() {
      location.reload()
    }
  },
  created() {
    this.merchantName = sessionStorage.getItem('merchantName')
    this.merchantId = sessionStorage.getItem('merchantId')
    this.merchantList = JSON.parse(
      sessionStorage.getItem('merchantList')
    ).filter(function (merchant) {
      return (
        merchant.merchantId !== sessionStorage.merchantId &&
        merchant.status !== 'disabled'
      )
    })
  }
}
</script>
